export enum CTA_ACTION {
    RELOAD = 'reload',
    GO_TO_LISTING_PAGE = 'go-to-listing-page',
}

export const MESSAGE_WIDGET_MODAL_CLOSE = 'widgetModalClose';
export const NATIVE_ORDER_CANCELED = 'OrderStatusCanceled';

export const RETRY_PARAM = 'retry';
export const RETRY_MAX_ATTEMPT = 1;

export const ACTION_RELOAD_CLICKED = 'ReloadClicked';
export const CATEGORY_ONE_CHECKOUT = 'one-checkout';
